import BigNumber from 'bignumber.js'

import { SwapOperation } from '@blade/chart-widget/models/chart-data'

import type { ChartPricePeriod } from '@blade/blockchain-types'
import type { DataHolderSwapData, SwapMaker } from '@blade/chart-widget'
import type { TradeApi } from '@root/shared/api'

export const mapFromModelToDataHolder = (
  order: TradeApi.MarketOrderDto,
  _pricePeriod: ChartPricePeriod,
  maker: SwapMaker,
): DataHolderSwapData => {
  const actualTime = new Date(order.updatedAt)
  const volumeUsd =
    order.type === 'buy'
      ? order.swapDetails?.amountInUsd
      : order.swapDetails?.amountOutUsd
  const volumeCurrency =
    order.type === 'buy'
      ? order.swapDetails?.amountIn
      : order.swapDetails?.amountOut

  return {
    id: order.id,
    operation: order.type === 'buy' ? SwapOperation.Buy : SwapOperation.Sell,
    tokenPriceInUsd: order.swapDetails?.tokenPriceInUsd
      ? BigNumber(order.swapDetails.tokenPriceInUsd)
      : BigNumber(0),
    marketCapUsd: order.swapDetails?.marketCap
      ? BigNumber(order.swapDetails.marketCap)
      : BigNumber(0),
    volumeUsd: volumeUsd ? BigNumber(volumeUsd) : BigNumber(0),
    quoteAmount: volumeCurrency ? BigNumber(volumeCurrency) : BigNumber(0),
    maker,
    txHash: order.txHash,
    actualTime,
  }
}
